module.exports = __webpack_public_path__ + "static/media/credit-card123.614e7911.svg";